module.exports = __webpack_public_path__ + "static/media/SofiaProLight.f55bb27c.woff2";